module.exports = __webpack_public_path__ + "img/Patrick Talley Resume 2021-1.a16e171f.png";